function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(9321 -8164)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  transform: "translate(-9321 8164)",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-12704.24 5767.014)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3481.015,2420.808a1.111,1.111,0,0,0,.758,1.157,6.859,6.859,0,0,0,3.884.292,4.064,4.064,0,0,0,1.357-.52c.544-.322.523-.85.012-1.22a2.075,2.075,0,0,0-.467-.265,6.6,6.6,0,0,0-3-.354l-.673.063s.024-4.5-.009-5.063a.627.627,0,0,1,.417-.684c2.506-1.248,5-2.515,7.506-3.771a.723.723,0,0,0,.49-.683.734.734,0,0,0-.5-.643c-2.883-1.433-5.775-2.851-8.641-4.317a.718.718,0,0,0-1.136.69Q3481.055,2413.148,3481.015,2420.808Zm1.892-13.516,5.015,2.5-5.015,2.512Z",
  transform: "translate(-83.618)",
  fill: "#71aff8",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3410.662,2577.621a6.865,6.865,0,0,0-2.383-1.295,20.926,20.926,0,0,0-6.383-1.055c-.6-.019-1.208,0-1.812.032,0,.634,0,1.268.023,1.9,1.3.024,2.6.046,3.9.117a11.638,11.638,0,0,1,4.07.946,8.2,8.2,0,0,1,1.287.705c.425.286.429.574.047.9a3.658,3.658,0,0,1-.688.449,14.889,14.889,0,0,1-6.368,1.382,24.448,24.448,0,0,1-5.547-.356,10.16,10.16,0,0,1-3.425-1.234c-.781-.464-.8-.886-.011-1.325a23.578,23.578,0,0,1,2.262-.967c.134-.057.364-.135.368-.212.031-.592.017-1.187.017-1.856-.48.127-.9.221-1.3.348a7.706,7.706,0,0,0-2.854,1.466,2.326,2.326,0,0,0,.094,3.82,8.118,8.118,0,0,0,2.657,1.318,20.822,20.822,0,0,0,5.69.893,24.017,24.017,0,0,0,6.766-.665,9.062,9.062,0,0,0,3.472-1.573A2.3,2.3,0,0,0,3410.662,2577.621Z",
  transform: "translate(0 -158.317)",
  fill: "#707070",
  fillRule: "evenodd"
})));

function SvgIconPlanQty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlanQty);
export default __webpack_public_path__ + "static/media/icon-planQty.28d7cd81.svg";
export { ForwardRef as ReactComponent };